import { create } from 'zustand'
import { rhAPI } from '../../api'
import { Cargo, CargoResume } from '../../types/rh/cargo'

interface CargoState {
  cleanCargoState: () => void
  filters: FiltersCargo
  setFilters: (filters: FiltersCargo | ((prev: FiltersCargo) => FiltersCargo)) => void
  cleanFilters: () => void
  isFiltered: () => boolean
  cargos: Cargo[]
  setCargos: (filters: FiltersCargo) => Promise<void>
  loadingCargos: boolean,
  setLoadingCargos: (loading: boolean) => void
  erroCargos: boolean,
  setErroCargos: (erro: boolean) => void
  messageErroCargos: string
  totalPages: number
  totalItems: number

  //CARGO RESUME
  cargoResume: CargoResume[]
  setCargoResume: () => Promise<void>
  erroCargoResume: boolean
  loadingCargoResume: boolean
  setErroCargoResume: (erro: boolean) => void

  //CARGO REGISTER
  selectedCargoId: number
  setSelectedCargoId: (id: number) => void
}

export interface FiltersCargo {
  pesquisarNome: string
  pesquisarAtribuicoes: string
  pesquisarEscolaridade: string
  status: number
  page: number
  pageSize: number
}

export const useCargoStore = create<CargoState>((set, get) => ({
  //CARGOS LIST
  cargos: [],
  setCargos: async (filters: FiltersCargo) => {
    set(() => ({ loadingCargos: true, erroCargos: false }))
    const result = await rhAPI.getCargos(filters)
    if (result.statusCode == 200 && result.data) {
      set(() => ({
        cargos: result.data?.items ?? [], filters: { ...filters, page: result.data?.currentPage ?? 1, pageSize: result.data?.pageSize ?? 25 }, totalPages: result.data?.totalPages ?? 0, totalItems: result.data?.totalItems ?? 0
      }))
    }
    else {
      set(() => ({ erroCargos: true, messageErroCargos: result.error?.Message ?? "Ocorreu um erro inesperado." }))
    }
    set(() => ({ loadingCargos: false }))
  },
  totalPages: 0,
  totalItems: 0,
  loadingCargos: false,
  setLoadingCargos: (loading: boolean) => {
    set(() => ({ loadingCargos: loading }))
  },
  erroCargos: false,
  setErroCargos: (erro: boolean) => {
    set(() => ({ erroCargos: erro }))
  },
  messageErroCargos: "",

  filters: { pesquisarNome: "", pesquisarAtribuicoes: "", pesquisarEscolaridade: "", status: 1, page: 1, pageSize: 25 },
  setFilters: (filters) => {
    set((state) => ({
      filters: typeof filters === 'function' ? filters(state.filters) : filters,
    }))
  },
  cleanFilters: () => {
    set(() => {
      const { setCargos } = get()
      const cleanedFilters: FiltersCargo = { pesquisarNome: "", pesquisarAtribuicoes: "", pesquisarEscolaridade: "", status: 1, page: 1, pageSize: 25 }
      setCargos(cleanedFilters)
      return ({
        filters: cleanedFilters
      })
    })
  },
  isFiltered: () => {
    const { filters } = get()
    if (filters.pesquisarNome != "" || filters.pesquisarAtribuicoes != "" || filters.pesquisarEscolaridade != "" || filters.status != 1) {
      return true
    }
    return false
  },

  //CARGOS RESUME
  cargoResume: [],
  erroCargoResume: false,
  loadingCargoResume: false,
  setCargoResume: async () => {
    set(() => ({ loadingCargoResume: true, erroCargoResume: false }))
    const result = await rhAPI.getCargosResume()
    if (result.statusCode == 200 && result.data) {
      set(() => ({ cargoResume: result.data }))
    }
    else {
      set(() => ({ erroCargoResume: true, cargoResume: [] }))
    }
    set(() => ({ loadingCargoResume: false }))
  },
  setErroCargoResume: (erro: boolean) => {
    set(() => ({ erroCargoResume: erro }))
  },

  //CARGOS REGISTER
  selectedCargoId: 0,
  setSelectedCargoId: (id: number) => {
    set(() => ({ selectedCargoId: id }))
  },

  cleanCargoState: () => {
    set(() => ({
      cargos: [],
      totalPages: 0,
      totalItems: 0,
      loadingCargos: false,
      erroCargos: false,
      messageErroCargos: "",
      filters: { pesquisarNome: "", pesquisarAtribuicoes: "", pesquisarEscolaridade: "", status: 1, page: 1, pageSize: 25 },
      cargoResume: [],
      erroCargoResume: false,
      loadingCargoResume: false,
      selectedCargoId: 0
    }))
  }
}))